import { Component, OnInit, ViewChild } from '@angular/core';
import * as XLSX from 'xlsx';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { PaymentRequestViewModel } from 'src/app/models/paymentRequestModel'
import { PaymentService } from 'src/app/_services/payment.service'
import { CancelPaymentComponent } from '../cancel-payment/cancel-payment.component';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmCancelPaymentComponent } from '../cancel-payment/confirm-cancel-payment/confirm-cancel-payment.component';
import { AuthService } from 'src/app/_services/auth.service';
import { AlertService } from 'src/app/_alert';
import { CommonService } from 'src/app/_services/common.service';
import { Subscription } from 'rxjs';
import { MatSort, Sort } from '@angular/material/sort';
import { LiveAnnouncer } from '@angular/cdk/a11y';

@Component({
  selector: 'app-payments',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.css']
})
export class PaymentsComponent implements OnInit {

  constructor(
    private paymentservice: PaymentService,
    public authService: AuthService,
    public alertService: AlertService,
    private _liveAnnouncer: LiveAnnouncer,
    public commonService: CommonService,
    public dialog: MatDialog
  ) { }

  subscription: Subscription;
  isLoading: boolean = false;
  options = {
    autoClose: true,
    keepAfterRouteChange: true,
  };

  PaymentDetail: PaymentRequestViewModel[] = [];
  openPaymentDetail: PaymentRequestViewModel[] = [];
  successPaymentDetail: PaymentRequestViewModel[] = [];
  failedPaymentDetail: PaymentRequestViewModel[] = [];
  expiredPaymentDetail: PaymentRequestViewModel[] = [];
   // =================== BULK UPLOAD VARIABLES =================== //
  selectedFile: File | null = null;
  isUploading = false;
  // preview before upload
  previewRows: any[] = [];
  previewColumns: string[] = [];
  showPreview = false;

  uploadResults: any[] = [];
  uploadSummary = { total: 0, success: 0, failed: 0 };

  uploadDisplayedColumns: string[] = [
  'CustTransactionId',
  'Status',
  'ResponseCode',
  'Message'
];

  @ViewChild('open') open: MatPaginator;
  @ViewChild('success') success: MatPaginator;
  @ViewChild('fail') fail: MatPaginator;
  @ViewChild('expired') expired: MatPaginator;

  @ViewChild(MatSort) openSort: MatSort;
  @ViewChild(MatSort) successSort: MatSort;
  @ViewChild(MatSort) failSort: MatSort;
  @ViewChild(MatSort) expireSort: MatSort;


  displayedColumns: string[] = ['srNo', 'trackingno', 'paymentlink', 'vendorName', 'borrowerName', 'expire'];
  displayedColumnsOpen: string[] = ['srNo', 'trackingno', 'paymentlink', 'vendorName', 'borrowerName', 'expire', 'cancel'];

  public dataSource = new MatTableDataSource(this.PaymentDetail);
  public openDataSource = new MatTableDataSource(this.openPaymentDetail);
  public successDataSource = new MatTableDataSource(this.successPaymentDetail);
  public failedDataSource = new MatTableDataSource(this.failedPaymentDetail);
  public expiredDataSource = new MatTableDataSource(this.expiredPaymentDetail);

  ngAfterViewInit() {
    // this.dataSource.paginator = this.paginator;
    this.openDataSource.paginator = this.open;
    this.successDataSource.paginator = this.success;
    this.failedDataSource.paginator = this.fail;
    this.expiredDataSource.paginator = this.expired;

    this.openDataSource.sort = this.openSort;
    this.successDataSource.sort = this.successSort;
    this.failedDataSource.sort = this.failSort;
    this.expiredDataSource.sort = this.expireSort;
  }

  ngOnInit(): void {
    this.allOpenPaymentReq('');
    this.allSuccessPaymentReq('');
    this.allFailedPaymentReq('');
    this.allExpiredPaymentReq('');
    this.subscription = this.commonService.refreshGrid$.subscribe((refresh) => {
      if (refresh) {
        this.allOpenPaymentReq('');
      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.openDataSource.filter = filterValue.trim().toLowerCase();
    this.successDataSource.filter = filterValue.trim().toLowerCase();
    this.failedDataSource.filter = filterValue.trim().toLowerCase();
    this.expiredDataSource.filter = filterValue.trim().toLowerCase();
  }

  getAllPaymentRequestList(partyId: string) {
    this.paymentservice.getAllPaymentRequestList(partyId).subscribe(
      (result: any) => {
        this.PaymentDetail = result;
        this.dataSource.data = this.PaymentDetail;
        console.log(result);
      },
    );
  }

  allOpenPaymentReq(partyId: string) {
    this.isLoading = true;
    this.paymentservice.allOpenPaymentReq(partyId).subscribe((openResult: any) => {
      this.openPaymentDetail = openResult;
      this.openDataSource.data = this.openPaymentDetail;
      console.log(openResult);
      this.isLoading = false;
    }, (err) => {
      console.log(err);
      this.alertService.error(err.error.errors.Messages[0], this.options);
      this.isLoading = false;
    })
  }

  allSettlePaymentReq(partyId: string) {
    this.isLoading = true;
    this.paymentservice.allSettlePaymentReq(partyId).subscribe((settleResult: any) => {
      this.PaymentDetail = settleResult;
      this.dataSource.data = this.PaymentDetail;
      console.log(settleResult);
      this.isLoading = false;
    }, (err) => {
      console.log(err);
      this.alertService.error(err.error.errors.Messages[0], this.options);
      this.isLoading = false;
    })
  }

  allFailedPaymentReq(partyId: string) {
    this.isLoading = true;
    this.paymentservice.allFailedPaymentReq(partyId).subscribe((failedResult: any) => {
      this.failedPaymentDetail = failedResult;
      this.failedDataSource.data = this.failedPaymentDetail;
      console.log(failedResult);
      this.isLoading = false;
    }, (err) => {
      this.alertService.error(err.error.errors.Messages[0], this.options);
      console.log(err);
      this.isLoading = false;
    })
  }

  allRemitPaymentReq(partyId: string) {
    this.isLoading = true;
    this.paymentservice.allRemitPaymentReq(partyId).subscribe((remitResult: any) => {
      this.PaymentDetail = remitResult;
      this.dataSource.data = this.PaymentDetail;
      console.log(remitResult);
      this.isLoading = false;
    }, (err) => {
      console.log(err);
      this.alertService.error(err.error.errors.Messages[0], this.options);
      this.isLoading = false;
    })
  }

  allExpiredPaymentReq(partyId: string) {
    this.isLoading = true;
    this.paymentservice.allExpiredPaymentReq(partyId).subscribe((expiredResult: any) => {
      this.expiredPaymentDetail = expiredResult;
      this.expiredDataSource.data = this.expiredPaymentDetail;
      console.log(expiredResult);
      this.isLoading = false;
    }, (err) => {
      console.log(err);
      this.alertService.error(err.error.errors.Messages[0], this.options);
      this.isLoading = false;
    })
  }

  allSuccessPaymentReq(partyId: string) {
    this.isLoading = true;
    this.paymentservice.allSuccessPaymentReq(partyId).subscribe((successResult: any) => {
      this.successPaymentDetail = successResult;
      this.successDataSource.data = this.successPaymentDetail;
      console.log(successResult);
      this.isLoading = false;
    }, (err) => {
      console.log(err);
      this.alertService.error(err.error.errors.Messages[0], this.options);
      this.isLoading = false;
    })
  }

  //Cancel payment
  public cancelPayment(trackingno: any, requestGUID: any) {
    this.dialog.open(CancelPaymentComponent, {
      width: '500px',
      disableClose: true,
      data: {
        TrackingNo: trackingno,
        AFSTransactionId: requestGUID,
        agentId: this.authService.getRegistredUserDetails().email,
      }
    })
  }

  announceSortChange(sortState: Sort) {
    console.log('fired vendor');
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  // =================== DOWNLOAD TEMPLATE =================== //
  downloadTemplate() {
    // Backend-required headers (must match server-side requiredHeaders)
    const header = `TrackingNo,LoanId,VendorId,VendorCompany,VendorContact,VendorAddressStreet,VendorAddressCity,VendorAddressState,VendorAddressZip,VendorContactEmail,ServiceCode,ServiceDescription,ServiceCharge,ServiceDate,PropertyAddressStreet,PropertyAddressCity,PropertyAddressState,PropertyAddressZip,PayeeCompany,PayeeNameFirst,PayeeNameLast,PayeeEmail,PayeePhone,SettlementRequired,SettleDate,CompletionRequired,RemitDate,PayeeType,SendPayeeEmail`;

    // Single sample row (one transaction) matching the header order above
    const sampleRowValues = [
      'TXN-1001',                       // TrackingNo
      'LN-2001',                        // LoanId
      'VND-3001',                       // VendorId
      'Appsolute Vendor 1',             // VendorCompany
      'John Doe',                       // VendorContact
      '123 Vendor St',                  // VendorAddressStreet
      'Arcadia',                        // VendorAddressCity
      'CA',                             // VendorAddressState
      '91007',                          // VendorAddressZip
      'vendor@example.com',             // VendorContactEmail
      'SC001',                          // ServiceCode
      'Inspection',                     // ServiceDescription
      '150.00',                         // ServiceCharge
      '2025-11-24',                     // ServiceDate
      '987 Borrower Ave',               // PropertyAddressStreet
      'San Diego',                      // PropertyAddressCity
      'CA',                             // PropertyAddressState
      '92130',                          // PropertyAddressZip
      'Payee Co',                       // PayeeCompany
      'Jane',                           // PayeeNameFirst
      'Doe',                            // PayeeNameLast
      'jane.doe@example.com',           // PayeeEmail
      '858-555-1234',                   // PayeePhone
      'No',                             // SettlementRequired
      '',                               // SettleDate
      'No',                             // CompletionRequired
      '',                               // RemitDate
      'Borrower',                     // PayeeType
      'Yes'                             // SendPayeeEmail
    ];

    const row = sampleRowValues.map(v => {
      // escape double quotes by doubling them and wrap fields that contain commas or quotes
      if (v == null) return '';
      const s = String(v);
      if (s.includes(',') || s.includes('"') || s.includes('\n')) {
        return '"' + s.replace(/"/g, '""') + '"';
      }
      return s;
    }).join(',');

    const csv = header + "\n" + row + "\n";
    try {
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'TransactionTemplate.csv';
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      this.alertService.error("Failed to generate template");
    }
  }

  // =================== FILE SELECT =================== //
  onFileSelected(event: any) {
    this.selectedFile = event.target.files[0] ?? null;
    if (this.selectedFile) {
      this.parseFilePreview(this.selectedFile);
    } else {
      this.previewRows = [];
      this.previewColumns = [];
      this.showPreview = false;
    }
  }

  // parse preview for CSV/XLSX
  parseFilePreview(file: File) {
    const name = file.name.toLowerCase();
    // Only allow CSV files for preview (project requirement: CSV only)
    if (name.endsWith('.csv')) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const text = e.target.result as string;
        const lines = text.split(/\r?\n/).filter(l => l.trim() !== '');
        if (lines.length === 0) {
          this.previewRows = [];
          this.previewColumns = [];
          this.showPreview = false;
          return;
        }
        const headers = lines[0].split(',').map(h => h.trim());
        const rows = lines.slice(1, 51).map(line => {
          const cols = line.split(',');
          const obj: any = {};
          headers.forEach((h, i) => obj[h] = cols[i] ? cols[i].trim() : '');
          return obj;
        });
        this.previewColumns = headers;
        this.previewRows = rows;
        // client-side check: detect duplicate TrackingNo values within the CSV preview
        const trackingIndex = headers.findIndex(h => h.toLowerCase() === 'trackingno');
        if (trackingIndex !== -1) {
          const seen: Record<string, number> = {};
          const duplicates: string[] = [];
          lines.slice(1).forEach(line => {
            if (!line || !line.trim()) return;
            const cols = line.split(',');
            const t = (cols[trackingIndex] || '').trim();
            if (!t) return;
            seen[t] = (seen[t] || 0) + 1;
            if (seen[t] === 2) duplicates.push(t);
          });
          if (duplicates.length) {
            this.alertService.warn('Duplicate TrackingNo found in file: ' + duplicates.slice(0,5).join(', ') + (duplicates.length>5? '...':''), this.options);
          }
        }
        this.showPreview = true;
      };
      reader.readAsText(file);
    } else {
      // unsupported file type — inform user and clear preview
      this.previewRows = [];
      this.previewColumns = [];
      this.showPreview = false;
      this.alertService.error('Only CSV files are supported. Please select a .csv file.');
    }
  }

  // =================== REMOVE FILE =================== //
  removeFile() {
    this.selectedFile = null;
    this.previewRows = [];
    this.previewColumns = [];
    this.showPreview = false;
  }

  // =================== FORMAT FILE SIZE =================== //
  formatFileSize(bytes: number): string {
    if (!bytes || bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
  }

  // =================== UPLOAD CSV FILE =================== //
 uploadCsv() {
  if (!this.selectedFile) {
    this.alertService.error("Please select a CSV file");
    return;
  }

  this.isUploading = true;

  this.paymentservice.uploadBulkTransactions(this.selectedFile).subscribe({
    next: (response: any) => {
      console.log("Upload Result:", response);

      // FIXED: API sends details array
      this.uploadResults = response?.details || [];

      // FIXED: API sends totalProcessed, successCount, failedCount
      this.uploadSummary = {
        total: response?.totalProcessed || 0,
        success: response?.successCount || 0,
        failed: response?.failedCount || 0,
      };

      this.alertService.success("Bulk Upload Completed");

      this.allOpenPaymentReq('');

      this.isUploading = false;
    },
    error: (err) => {
      console.error('Upload error', err);
      // Prefer server-provided message when available
      let message = 'Upload failed';
      try {
        if (err && err.error) {
          // APIResponse style
          if (err.error.ResponseDescription) message = err.error.ResponseDescription;
          else if (err.error.message) message = err.error.message;
          else message = JSON.stringify(err.error);
        } else if (err && err.message) {
          message = err.message;
        }
      } catch (ex) {
        console.error('Error extracting server message', ex);
      }

      this.alertService.error(message);
      this.isUploading = false;
    }
  });
}
}